export default "__VITE_ASSET__26387980__"